<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
        :readOnly="readOnly"
        :isLoss="isLoss"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isLoss: {
      type: Boolean,
      default: false,
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_EXIT_STORAGE_ADJUSTMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          // console.log("context", response.data.accountContext);
          this.editableEntry = response.data.accountContext.exitStorageAdjustment;
          // console.log("this.editableEntry exit storage adjustment", this.editableEntry)
          
          // this.editableEntry.isLoss = this.isLoss;
          this.isLoss = this.editableEntry.isLoss;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(exitStorageAdjustment) {
      this.pageLoading = true;
      if(!this.editableEntry.enabledLots){
        this.editableEntry.exitMovementItemsAttributes.forEach(
          function(item){
            delete item.exitMovementItemLotsAttributes;
          }
        );
      }
      this.$apollo
        .mutate({
          mutation: UPDATE_EXIT_STORAGE_ADJUSTMENT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(exitStorageAdjustment, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateExitStorageAdjustment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_EXIT_STORAGE_ADJUSTMENT_QUERY = gql `
query ($id: ID!) {
  accountContext {
    exitStorageAdjustment(id: $id) {
        id
        code
        date
        description
        isLoss
        removeFromStorage
        enabledLots
        isStockEntryType
        storageId
        storage {
          id
          name
        }
        stockAdjustmentReasonId
        stockAdjustmentReason {
          id
          name
        }
        exitMovementItemsAttributes {
          id
          quantity
          hasLot
          packagingQuantity
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
            typeText
          }
          packagingId
          packaging {
            id
            name
            unitName
            size
            text
          }
          validations
        }
        dummyExitMovementItemsAttributes {
          id
          quantity
          hasLot
          packagingQuantity
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
            typeText
          }
          packagingId
          packaging {
            id
            name
            unitName
            size
            text
          }
          validations
        }
        validations
      }
      allStorages {
        id
        name
        location
      }
      allGreenhouses{
        id
        name
        location
      }
      allStockAdjustmentReasons {
        id
        name
      }
    }
  }
`;

const UPDATE_EXIT_STORAGE_ADJUSTMENT_MUTATION = gql `
  mutation($input: ExitStorageAdjustmentUpdateInputObject!) {
    updateExitStorageAdjustment(input: $input) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>